<template>
  <v-container>
    <v-row align="center" justify="center" width="100%">
      <v-card light flat style="width: 21cm;">
        <v-card-text>
          <v-row>
            <v-col xs="12" class="mt-1 pa-0">
              <v-row>
                <v-col xs="6" class="text-left pr-0 pl-4">
                  <img responsive width="80%" :src="logoPath"/>
                  <br/>
                  <div class="text-left" style="width: 80%;">
                    <span v-html="contactInfo ? $root.newLineToBR(contactInfo) : null"></span>
                  </div>
                </v-col>
                <v-col xs="6" class="pt-5">
                  <div style="border-left: 4px #999 solid" class="pl-2">
                    <v-simple-table dense class="mb-5">
                      <template v-slot:default>
                        <tbody>
                        <tr>
                          <th class="text-left" colspan="2">
                            <h1>Totals</h1>
                          </th>
                        </tr>
                        <template v-for="key in Object.keys(totalsCountsNames)">
                          <tr :key="key">
                            <td class="text-left">{{totalsCountsNames[key]}}</td>
                            <template v-if="totalsCountsTypes[key] === 'Miles'">
                              <td class="text-left">{{totalsCounts[key]}}{{$t('milesShort')}}</td>
                            </template>
                            <template v-else-if="totalsCountsTypes[key] === 'Money'">
                              <td class="text-left">{{$root.moneyValue(totalsCounts[key], 0)}}</td>
                            </template>
                            <template v-else>
                              <td class="text-left">{{totalsCounts[key]}}</td>
                            </template>
                          </tr>
                        </template>
                        </tbody>
                      </template>
                    </v-simple-table>
                  </div>
                </v-col>
              </v-row>
              <h3 style="line-height: 32px;" class="text-center" v-html="title"></h3>
              <v-simple-table v-if="data.hasOwnProperty('expenses')"
                              dense
                              style="border: 1px solid #000; width:100%;background: transparent;"
                              class="text-left">
                <tbody>
                <tr style="background:#0090D3;color:#fff;page-break-inside: avoid;">
                  <th class="report_font_size text-center">Trx Date</th>
                  <th class="report_font_size text-center">Created</th>
                  <th class="report_font_size text-center">Load</th>
                  <th class="report_font_size text-center">Driver</th>
                  <th class="report_font_size text-center">Type</th>
                  <th class="report_font_size text-center">Method</th>
                  <th class="report_font_size text-center">Truck</th>
                  <th class="report_font_size text-center">Transaction #</th>
                  <th class="report_font_size text-center">Product</th>
                  <th class="report_font_size text-center">Qty</th>
                  <th class="report_font_size text-center">PerItem</th>
                  <th class="report_font_size text-center">Amount</th>
                </tr>
                <tr v-for="item in data.expenses" style="page-break-inside: avoid;" :key="'entry'+item.id">
                  <td class="report_font_size">{{item.TrxDate.substring(0, 10)}}<br/>{{item.TrxDate.substring(10)}}</td>
                  <td class="report_font_size">#{{item.loadId}}<br/><v-icon v-if="item.Transaction" small>mdi-import</v-icon></td>
                  <td class="report_font_size">{{item.userCreatedFirstName}}<br/>{{item.userCreatedLastName}}</td>
                  <td class="report_font_size">{{item.userFirstName}}<br/>{{item.userLastName}}</td>
                  <td class="report_font_size">
                    <span v-if="item.compensateCode === 0">{{$t('Expenses')}}</span>
                    <span v-else-if="item.compensateCode === 1">{{$t('Compensate')}}</span>
                    <span v-else-if="item.compensateCode === 2">{{$t('AddToSalary')}}</span>
                    <span v-else-if="item.compensateCode === 3">{{$t('Fine')}}</span>
                  </td>
                  <td class="report_font_size">{{item.paymentMethod}}</td>
                  <td class="report_font_size">{{item.truckName}}</td>
                  <td class="report_font_size">{{item.Transaction}}</td>
                  <td class="report_font_size">{{item.Product}}</td>
                  <td class="report_font_size">{{item.Quantity}}</td>
                  <td class="report_font_size">{{$root.moneyValue(item.InvoiceAmount/item.Quantity, 2)}}</td>
                  <td class="report_font_size">{{$root.moneyValue(item.InvoiceAmount, 2)}}</td>
                </tr>
                </tbody>
              </v-simple-table>
              <template v-if="reportData && reportData.hasOwnProperty('footerText')">
                {{reportData.footerText}}
              </template>
              <template v-else>
                Report Created at {{currentDateTime}}&nbsp;by&nbsp;{{$store.getters.currentUserName}}
              </template>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-row>
  </v-container>
</template>

<script>
import reportsMixin from '../../mixins/reportsMixin.js';

export default {
  name: 'TruckReportTemplate',
  props: ['reportData', 'entries', 'print', 'from', 'to', 'truckName', 'totals', 'currentDateTime', 'companyId'],
  mixins: [reportsMixin],
  components: {},
  data: function () {
    return {
      publicPath: process.env.BASE_URL,
      contactInfo: '',
      title: '',
      logoPath: '',
      data: {}
    };
  },
  computed: {
    totalsCounts () {
      return this.data;
    },
    totalsCountsNames () {
      return this.$store.getters['reports/totalsCountsNames'];
    },
    totalsCountsTypes () {
      return this.$store.getters['reports/totalsCountsTypes'];
    }
  },
  mounted () {
    this.setExpensesTotalsHeaders();

    if (this.entries) {
      this.$set(this, 'data', this.totals);
      this.$set(this.data, 'expenses', this.entries);
    } else {
      this.$set(this, 'data', this.reportData);
    }
    this.$root.getInvoiceLogoPath(this.companyId).then(path => {
      this.logoPath = path;
    });
    this.$root.getGlobalSettingsField('invoiceContactInfo', this.companyId).then((response) => {
      if (response.status === 'ok') {
        this.contactInfo = response.result;
      }
    });
    this.title = this.reportTitle();
    document.title = this.title;
  },
  methods: {
    reportTitle () {
      let result = this.$root.t('Report') + ' ' + (this.$route.params.report_number ? '#' + this.$route.params.report_number : '') + ': ';
      this.$root.currentReportFileName = this.$root.t('Report') + (parseInt(this.$route.params.report_number) > 0 ? '_' + this.$route.params.report_number : '') + '_';

      if (this.data.expenses &&
        this.data.expenses.length > 1 &&
        this.data.expenses[0].hasOwnProperty('startedPST') &&
        this.data.expenses[this.data.expenses.length - 1].hasOwnProperty('endedPST')) {
        result += this.data.expenses[0].startedPST.substring(0, 10) + ' - ' + this.data.expenses[this.data.expenses.length - 1].endedPST.substring(0, 10);
        this.$root.currentReportFileName += this.$root.parseDate(this.data.expenses[0].startedPST.substring(0, 10)) + '-' + this.$root.parseDate(this.data.expenses[this.data.expenses.length - 1].endedPST.substring(0, 10));
      }
      if (this.data.expenses && this.data.expenses.length === 1 && this.data.expenses[0].hasOwnProperty('startedPST')) {
        result += this.data.expenses[0].startedPST.substring(0, 10);
        this.$root.currentReportFileName += this.$root.parseDate(this.data.expenses[0].startedPST.substring(0, 10));
      }

      return result;
    }
  }
};
























</script>
